export function getPasswordInputErrorProps(error) {
  return error === true ? { showError: true } : null
}
